import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sm-image-preview-popover',
    template: require('./sm-image-preview-popover.component.html')
})
export class SmImagePreviewPopoverComponent implements OnInit {
    @Input() imageThumbnail: string;
    @Input() imagePreview: boolean;
    @ViewChild('popover') popover: NgbPopover;

    constructor(
    ) { }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-image-preview-popover.component.ts